import { render, staticRenderFns } from "./customer-order-list.vue?vue&type=template&id=6e20bd19&"
import script from "./customer-order-list.vue?vue&type=script&lang=ts&"
export * from "./customer-order-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports